import { AdminDashboardStatsRO } from '@routellers/types/dist/openapi/admin/admin-dashboard-stats.ro';

import { ApiMethodDeclaration } from '..';

const stats: ApiMethodDeclaration<void, AdminDashboardStatsRO> = () => ({
    url: '/admin/dashboard/stats',
    method: 'GET',
});

export const adminDashboardApiDeclaration = {
    stats,
};
